import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import reload from "../../Assets/reloardform.svg";
import deleteIcon from "../../Assets/Delete.svg";
import plustracking from "../../Assets/plustracking.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  APIDataUrl,
  APITokenUrl,
  GetUserId,
  SetPersonId,
} from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import AddCircleIcon from "@mui/icons-material/AddCircle";
const ProspectTracking = ({
  prospectData,
  handleRefreshTrackingdata,
  handleDeleteTracking,
  setLoading,
  
  
}) => {
  const navigate = useNavigate();
  const [feedData, setFeedData] = useState([]);
  const handleProspect = (item) => {
    navigate(`/Profile/${item?.person_id == 0 ? "0" : item?.person_id}`);
  };
  const handleAddStream = (item) => {
    if (feedData.length >= 3) {
      toast.error("No empty streams are available.");
      return;
    }
    const allowedIds = [1, 2, 3];
    const presentIds = feedData?.map((i) => i.content_box_id) || [];
    const missingIds = allowedIds.filter((id) => !presentIds.includes(id));
    saveContentFeed(Number(item?.person_id), missingIds[0]);
  };
  const getContentFeed = () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_feed_box?user_id=${GetUserId()}`,
    };
    axios(options)
      .then((e) => {
        let data = e?.data;
        setFeedData(data);
      })
      .catch((error) => {
        console.error("Error fetching feed:", error);
      });
  };
  useEffect(() => {
    getContentFeed();
  }, []);
  const saveContentFeed = (id, value) => {
    const data = {
      id: 0,
      user_id: GetUserId(),
      context_box: value,
      people_id: id ? id : 0,
      request_id: 0,
      org_id: 0,
      location: "",
      tags: "",
      industry: "",
      document_type: "news",
    };
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/save_feed_box`,
    };
    axios(options)
      .then(() => {
        navigate("/dashboard");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  return (
    <div className="table-enrich">
      <h3 className="track_head">Prospect Tracking List</h3>
    <TableContainer component={Paper} className="DecisionMaker-table-main">
      <Box
        sx={{ margin: 1 }}
        id="scrollableDiv"
        className="ai-leads-table-inner_favourites"
      >
        <Table aria-label="collapsible table" className="ai-leads-table">
          <TableHead>
            <TableRow className="table-row-ai-leads">
              <TableCell className="score-row-table">Name</TableCell>
              <TableCell className="score-row-table">
                Organization
              </TableCell>
              <TableCell className="score-row-table">
                Created Date
              </TableCell>
              <TableCell className="score-row-table">
                Expiration Date
              </TableCell>
              <TableCell className="score-row-table"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {prospectData?.map((item, index) => (
              <TableRow className="table-row-ai-leads">
                <TableCell className="checkbox-row-table-inner checkbox-row-table cursor_pointer">
                  <div
                    className="enrich-table-content"
                    style={{ cursor: "pointer" }}
                  >
                    <p onClick={() => handleProspect(item)}>
                      {item?.first_name === "jp"
                        ? "JP"
                        : item?.first_name || "-"}{" "}
                      {item?.last_name}
                    </p>
                  </div>
                </TableCell>
                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                  <div className="enrich-table-content">
                    <p>
                      {" "}
                      {item?.organization_name
                        ? item?.organization_name
                        : ""}
                    </p>
                  </div>
                </TableCell>
                <TableCell component="th" scope="row">
                  <div className="enrich-table-content">
                    <p>{moment(item?.updated_at).format("DD MMM YYYY")}</p>
                  </div>
                </TableCell>
                <TableCell component="th" scope="row">
                  <div className="enrich-table-content">
                    <p>{moment(item?.track_until).format("DD MMM YYYY")}</p>
                  </div>
                </TableCell>
                <TableCell align="right" className="three-dot-cell">
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() => handleDeleteTracking(item)}
                  >
                    <img src={deleteIcon} alt="" />
                  </span>
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() => {
                      handleRefreshTrackingdata(item);
                    }}
                  >
                    <img src={reload} alt="" />
                  </span>
                  {feedData.some(
                    (feed) =>
                      String(feed?.people_id) === String(item?.person_id),
                  ) ? (
                    <span className="threeDotIcon-table-profile">
                      <AddCircleIcon className="addIconGreen" />
                    </span>
                  ) : (
                    <span
                      className="threeDotIcon-table-profile"
                      onClick={() => {
                        handleAddStream(item);
                      }}
                    >
                      <img src={plustracking} alt="Add tracking" />
                    </span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
    </div>
  );
};
export default ProspectTracking;
